import { render, staticRenderFns } from "./DataReportTableCard.vue?vue&type=template&id=b273a3ee&scoped=true&"
import script from "./DataReportTableCard.vue?vue&type=script&lang=js&"
export * from "./DataReportTableCard.vue?vue&type=script&lang=js&"
import style0 from "./DataReportTableCard.vue?vue&type=style&index=0&id=b273a3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b273a3ee",
  null
  
)

export default component.exports